import React, { useRef, useState } from 'react';

const isMobile = () => typeof window !== 'undefined' && window.innerWidth <= 900;

export default function Carousel({ children, itemsToShowDesktop = 3, itemsToShowMobile = 1, style = {}, className = '' }) {
  const [index, setIndex] = useState(0);
  const containerRef = useRef(null);
  const total = React.Children.count(children);
  const mobile = isMobile();
  const itemsToShow = mobile ? itemsToShowMobile : itemsToShowDesktop;

  // Gestion du swipe tactile
  let startX = null;
  let isSwiping = false;

  const onTouchStart = (e) => {
    isSwiping = true;
    startX = e.touches[0].clientX;
  };
  const onTouchMove = (e) => {
    if (!isSwiping || startX === null) return;
    const dx = e.touches[0].clientX - startX;
    if (Math.abs(dx) > 50) {
      if (dx < 0) next();
      else prev();
      isSwiping = false;
      startX = null;
    }
  };
  const onTouchEnd = () => {
    isSwiping = false;
    startX = null;
  };

  const next = () => {
    setIndex(i => Math.min(i + 1, total - itemsToShow));
  };
  const prev = () => {
    setIndex(i => Math.max(i - 1, 0));
  };

  // Pagination
  const pageCount = Math.max(1, total - itemsToShow + 1);
  const goTo = (i) => setIndex(i);

  // Découpe les enfants à afficher
  const visibleChildren = React.Children.toArray(children).slice(index, index + itemsToShow);

  return (
    <div
      className={`carousel-container ${className}`}
      style={{ position: 'relative', width: '100%', ...style }}
      ref={containerRef}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* Flèche gauche */}
      {index > 0 && (
        <button
          className="carousel-arrow carousel-arrow-left"
          onClick={prev}
          style={{
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
            background: 'rgba(255,255,255,0.85)',
            border: 'none',
            borderRadius: '50%',
            width: 40,
            height: 40,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            color: '#222',
            cursor: 'pointer',
            transition: 'background 0.2s',
          }}
          aria-label="Précédent"
        >
          <span style={{ fontWeight: 700 }}>&#8592;</span>
        </button>
      )}
      {/* Flèche droite */}
      {index < total - itemsToShow && (
        <button
          className="carousel-arrow carousel-arrow-right"
          onClick={next}
          style={{
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
            background: 'rgba(255,255,255,0.85)',
            border: 'none',
            borderRadius: '50%',
            width: 40,
            height: 40,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            color: '#222',
            cursor: 'pointer',
            transition: 'background 0.2s',
          }}
          aria-label="Suivant"
        >
          <span style={{ fontWeight: 700 }}>&#8594;</span>
        </button>
      )}
      <div
        className="carousel-track"
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 'var(--spacing-md)',
          overflow: 'hidden',
          width: '100%',
          justifyContent: mobile ? 'center' : 'flex-start',
        }}
      >
        {visibleChildren}
      </div>
      {/* Pagination points */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
        marginTop: 18,
        marginBottom: 6,
      }}>
        {Array.from({ length: pageCount }).map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            style={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              border: 'none',
              background: i === index ? 'var(--color-melange, #222)' : '#e0e0e0',
              boxShadow: i === index ? '0 0 0 2px #bbb' : 'none',
              cursor: 'pointer',
              transition: 'background 0.2s',
              outline: 'none',
              padding: 0,
              margin: 0,
              display: 'inline-block',
            }}
            aria-label={`Aller à la page ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
} 